import { Languages } from 'lucide-react';

import { useLocale, useTranslations } from '@/i18n/use-locale';
import { interactive } from '@/components/ui/interactive';
import { cn } from '@/lib/utils';

/**
 * A one-click switch to the other language, for pages outside the shell.
 *
 * The console's own switch lives in the account menu, which only exists once
 * someone is signed in — so without this, an English-speaking admin met the
 * password and code steps in Arabic with no way out. It names the other
 * language in itself ("English" / "العربية"), so it is readable whichever one
 * is on, the same rule the account menu follows.
 */
export function LanguageSwitch({ className }: { className?: string }) {
  const { locale, setLocale } = useLocale();
  const t = useTranslations('admin.header');

  return (
    <button
      type="button"
      onClick={() => setLocale(locale === 'ar' ? 'en' : 'ar')}
      aria-label={t('switchLanguage')}
      className={cn(
        interactive,
        'inline-flex items-center gap-1.5 rounded-lg border border-conc-100 bg-white px-3 py-1.5 text-[13px] font-semibold text-navy shadow-sm hover:border-pitch hover:text-pitch',
        className,
      )}
    >
      <Languages aria-hidden className="h-4 w-4" />
      <span lang={locale === 'ar' ? 'en' : 'ar'}>
        {locale === 'ar' ? t('languageEnglish') : t('languageArabic')}
      </span>
    </button>
  );
}
